export default __webpack_public_path__ + "static/media/pdfBigLogo.193794a4.svg";